import React, { Component } from 'react'
import TablaDistribucionPorCondicion from '../../shared/distribucionPorCondicion/containers/TablaDistribucionPorCondicion'
import TablaDetallePorCondicionLinea12 from '../../detallesDistribucionPorCondicion/detallePorCondicionLinea12/containers/TablaDetallePorCondicionLinea12'
import TablaDetallePorCondicionLinea3 from '../../detallesDistribucionPorCondicion/detallePorCondicionLinea3/containers/TablaDetallePorCondicionLinea3'
import TablaDetallePorCondicionLinea4 from '../../detallesDistribucionPorCondicion/detallePorCondicionLinea4/containers/TablaDetallePorCondicionLinea4'
import TablaDetallePorCondicionLinea5 from '../../detallesDistribucionPorCondicion/detallePorCondicionLinea5/containers/TablaDetallePorCondicionLinea5'

export class DistribucionPorCondicionDetallesView extends Component {
  render () {
    return (
      <>
        <TablaDistribucionPorCondicion conLink={false} />
        <TablaDetallePorCondicionLinea12 />
        <TablaDetallePorCondicionLinea3 />
        <TablaDetallePorCondicionLinea4 />
        <TablaDetallePorCondicionLinea5 />
      </>
    )
  }
}
